var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"agreement"},[_vm._v(" 注册登录即表示已阅读并同意 "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.userservices}},[_vm._v("《用户服务协议》")]),_vm._v(" 和 "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.userprivacy}},[_vm._v("《用户隐私协议》")])])
}
var staticRenderFns = []

export { render, staticRenderFns }